// extracted by mini-css-extract-plugin
export default {"dailyFee":"daily-fee_dailyFee__NZeUE","feeNote":"daily-fee_feeNote__c51Bm"};